import { inject, Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { Observable } from 'rxjs'
import { environment } from '../../../../environments/environment'
import { InsertionChantierDto } from './dto/insertion-chantier.dto'
import { CreateInsertionChantierDto } from './dto/create-insertion-chantier.dto'
import { PatchInsertionChantierDto } from './dto/patch-insertion-chantier.dto'

@Injectable({ providedIn: 'root' })
export class InsertionChantierHttpService {
  private static readonly endpoint = environment.baseUrl + '/insertions-chantiers'
  private readonly http = inject(HttpClient)

  createInsertionChantier(codeChantier: string, params: CreateInsertionChantierDto): Observable<InsertionChantierDto> {
    return this.http.post<InsertionChantierDto>(`${InsertionChantierHttpService.endpoint}/${codeChantier}`,  params )
  }

  deleteInsertionChantier(id: number): Observable<void> {
    return this.http.delete<void>(`${InsertionChantierHttpService.endpoint}/${id}`)
  }

  getAllInsertionsChantierByCodeChantier(codeChantier: string):Observable<InsertionChantierDto[]> {
    return this.http.get<InsertionChantierDto[]>(`${InsertionChantierHttpService.endpoint}/${codeChantier}` );
  }
  patchInsertionChantier(id: number, dto : PatchInsertionChantierDto ): Observable<InsertionChantierDto> {
    return this.http.patch<InsertionChantierDto>(`${InsertionChantierHttpService.endpoint}/${id}`, dto)
  }
}
